/* @flow */

import {
  disableLoginLinkFeature,
  profileEditionBraindateOnly,
  klikPlugin,
  githubProfileFeature,
  onboardingIntroAFeature,
  marketPromptsFeature,
  improvedTopicCardFeature,
  selfCheckInPlugin,
  manualAvailabilityFeature,
  interestsFeature,
  lightThemeFeature,
  customFontPlugin,
  emailPlugin,
  smsPlugin,
  doubleDutchPlugin,
  signupPlugin,
  slackPlugin,
  googleSyncPlugin,
  outlookSyncPlugin,
  helpFeature,
  hideAccountPrefsFeature,
  moderationPlugin,
  backToAppPlugin,
  customMenuPlugin,
  topicDisclaimerPlugin,
  videoCallPlugin,
  videoCallFeedbackFeature,
} from 'src/shared/app/feature/settings/featureSettings';

export function createFeatureRouter() {
  let internalConfig = {};

  return {
    setFeature(featureName: string, isEnabled: boolean): void {
      internalConfig[featureName] = isEnabled;
    },
    isFeatureEnabled(featureName: string): boolean {
      return internalConfig[featureName];
    },
    reset(): void {
      internalConfig = {};
    },
  };
}

export function createFeatureDecisions(featureRouter: Object): Object {
  return {
    // Onboarding
    isOnboardingUsingIntroScreenVersionA() {
      return featureRouter.isFeatureEnabled(onboardingIntroAFeature);
    },
    // Market
    areMarketPromptsEnabled() {
      return featureRouter.isFeatureEnabled(marketPromptsFeature);
    },
    isImprovedTopicCard() {
      return featureRouter.isFeatureEnabled(improvedTopicCardFeature);
    },
    // Signup
    isSignupEnabled() {
      return featureRouter.isFeatureEnabled(signupPlugin);
    },
    // Login
    isLoginLinkShownInSupport() {
      return featureRouter.isFeatureEnabled(disableLoginLinkFeature);
    },
    // Profile
    isKlikIntegrationEnabled() {
      return featureRouter.isFeatureEnabled(klikPlugin);
    },
    isGithubProfileEnabled() {
      return featureRouter.isFeatureEnabled(githubProfileFeature);
    },
    isProfileEditionBraindateOnly() {
      return featureRouter.isFeatureEnabled(profileEditionBraindateOnly);
    },
    // Preferences
    isAccountPrefsSectionHidden() {
      return featureRouter.isFeatureEnabled(hideAccountPrefsFeature);
    },
    // Availability
    isGoogleSyncEnabled() {
      return featureRouter.isFeatureEnabled(googleSyncPlugin);
    },
    isOutlookSyncEnabled() {
      return featureRouter.isFeatureEnabled(outlookSyncPlugin);
    },
    isManualAvailabilityEnabled() {
      return featureRouter.isFeatureEnabled(manualAvailabilityFeature);
    },
    isPersonalScheduleSyncEnabled() {
      return (
        featureRouter.isFeatureEnabled(googleSyncPlugin) ||
        featureRouter.isFeatureEnabled(outlookSyncPlugin) ||
        featureRouter.isFeatureEnabled(manualAvailabilityFeature)
      );
    },
    // Self check-in
    isSelfCheckInEnabled() {
      return featureRouter.isFeatureEnabled(selfCheckInPlugin);
    },
    // Notifications
    areEmailNotificationsEnabled() {
      return featureRouter.isFeatureEnabled(emailPlugin);
    },
    areSMSNotificationsEnabled() {
      return featureRouter.isFeatureEnabled(smsPlugin);
    },
    isNotificationPromptShown() {
      return featureRouter.isFeatureEnabled(emailPlugin);
    },
    // Third party integration
    isDoubleDutchIntegrationEnabled() {
      return featureRouter.isFeatureEnabled(doubleDutchPlugin);
    },
    isSlackIntegrationEnabled() {
      return featureRouter.isFeatureEnabled(slackPlugin);
    },
    // Help
    isHelpEnabled() {
      return featureRouter.isFeatureEnabled(helpFeature);
    },
    // Navigation
    hasBackToAppLink() {
      return featureRouter.isFeatureEnabled(backToAppPlugin);
    },
    hasCustomMenu() {
      return featureRouter.isFeatureEnabled(customMenuPlugin);
    },
    // Moderation
    isModerationEnabled() {
      return featureRouter.isFeatureEnabled(moderationPlugin);
    },
    // Fonts
    hasCustomFont() {
      return featureRouter.isFeatureEnabled(customFontPlugin);
    },
    // New topic
    areNewProfileQuestionsEnabled() {
      return featureRouter.isFeatureEnabled(interestsFeature);
    },
    areInterestsEnabled() {
      return featureRouter.isFeatureEnabled(interestsFeature);
    },
    isTopicDisclaimerEnabled() {
      return featureRouter.isFeatureEnabled(topicDisclaimerPlugin);
    },

    // Light theme
    useLightTheme() {
      return featureRouter.isFeatureEnabled(lightThemeFeature);
    },

    // Video calls
    isVideoCallEnabled() {
      return featureRouter.isFeatureEnabled(videoCallPlugin);
    },

    isVideoCallFeedbackEnabled() {
      return featureRouter.isFeatureEnabled(videoCallFeedbackFeature);
    },
  };
}
